import React from "react"
import i18n from "i18next"
import { Layout, Head as HeadComponent } from "@bw/layouts"
import { PageHeader } from "@bw/modules"
import { Section } from "@bw/bits"
import { Authentication } from "@bw/partials"
import { useTranslation } from "react-i18next"
import { useUser } from "contexts/user"
import { login, register, forgot } from "services/authentication"

export const Head = ({ location, pageContext }) => (
  <HeadComponent
    title={i18n.t("account:loginTitle")}
    location={location}
    pageContext={pageContext}
    doNotIndex
  />
)

const Login = ({ pageContext, location }) => {
  const [user, dispatch] = useUser()
  const { t } = useTranslation()

  const afterLogin = React.useCallback(
    response => {
      const { token, user } = response.data.data
      dispatch({
        type: "LOGIN",
        profile: user,
        token,
      })
    },
    [dispatch]
  )

  return (
    <Layout {...{ pageContext, location }}>
      <PageHeader title={t("account:loginTitle")} />
      <Section>
        <Authentication
          step="login"
          onSubmitLogin={data => login(data).then(afterLogin)}
          onSubmitRegister={data => register(data).then(afterLogin)}
          onSubmitForgot={forgot}
          user={user}
        />
      </Section>
    </Layout>
  )
}

export default Login
